import SigliveServiceV1 from 'Service/sigliveServiceV1';

const patchUser = async ({ payload, id }) => {
  const { data } = await SigliveServiceV1({ method: 'PATCH', url: `/user/${id}`, data: payload });

  return data;
};

export default patchUser;
